import { makeStyles } from "@material-ui/core/styles";

export const eodItemStyles = makeStyles(theme => ({
  root1: {
    //flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: "3em",
    textAlign: "center",
    color: theme.palette.text.secondary
    // width:"30em"
  },
  commonTypography: {
    fontSize: "1.15rem",
    fontWeight: "bolder",
    color: "#000",
    // fontFamily: "Roboto"
  },
  subContentTypography: {
    fontSize: "0.875rem",
    color: "#000",
    fontWeight: "bold",
    // fontFamily: "Roboto"
  },
  eodReportPadding: {
    paddingLeft: "4em",
    paddingRight: "4em"
  },
  textStyle: {
    color: "#000",
    fontWeight: "bold",
    // fontFamily: "Roboto"
  },
  FinancialReportTitle: {
    fontWeight: "bolder",
    color: "#000",
    // fontFamily: "Roboto"
  },
  gridPriceAlignment: {
    textAlign: "right",

  },
  table: {
    minWidth: 935,
  },
  detailIconMargin: {
    marginRight: theme.spacing(1),
    backgroundColor: "white",//"#8bc34a",
    boxShadow: "none",
    borderRadius: "3em",
    "&:hover": {
      backgroundColor: "#717d8a",
    }
  },
  detailIcon: {
    width: ".90em",
    height: ".90em",
    color: "#3d5a79 !important",
  },
  SearchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  searchPaper: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: 400,
  },
  progressRoot: {
    width: "100%",
  },
  mainPaper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  fab: {
    marginLeft: "2em",
    // backgroundColor: "green",
  },
  buttonProgress: {
    position: 'absolute',
    top: '5%',
    left: '85%'
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  errorMessageStyle: {
    color: "black", fontSize: "1.5em", padding: "1em"
  },
  dialogTitleStyle: {
    color: "white", fontSize: "20px"
  }
}));
